import { formatConstant } from '@/modules/common/lib/string';
import { PaymentStatus } from '@/types/payment';
import {
  ArrowForward,
  Cancel,
  CheckCircle,
  Schedule,
} from '@mui/icons-material';
import { Chip } from '@mui/material';

interface PaymentStatusChipProps {
  status: PaymentStatus;
  size?: 'small' | 'medium';
}

export const PaymentStatusChip = ({
  status,
  size = 'small',
}: PaymentStatusChipProps) => {
  const getStatusConfig = (status: PaymentStatus) => {
    switch (status) {
      case PaymentStatus.Pending:
      case PaymentStatus.WaitingFunds:
        return {
          className: 'text-primary',
          backgroundColor: '#C2C2C280',
          icon: <Schedule className="text-primary text-sm" />,
        };
      case PaymentStatus.Paid:
        return {
          className: 'text-success',
          backgroundColor: '#B9E0D080',
          icon: <CheckCircle className="text-success text-sm" />,
        };
      case PaymentStatus.Authorized:
        return {
          className: 'text-primary',
          backgroundColor: '#ABBAEB80',
          icon: <CheckCircle className="text-primary text-sm" />,
        };
      case PaymentStatus.Failed:
        return {
          className: 'text-error',
          backgroundColor: '#F8AEAD80',
          icon: <Cancel className="text-error text-sm" />,
        };
      case PaymentStatus.Expired:
        return {
          className: 'text-warning',
          backgroundColor: '#F3A77B66',
          icon: <Schedule className="text-warning text-sm" />,
        };
      case PaymentStatus.InCheckout:
        return {
          className: 'text-[#895AD7]',
          backgroundColor: '#E6DEFF',
          icon: <ArrowForward className="text-[#895AD7] text-sm" />,
        };
      default:
        return {
          className: 'text-gray-800',
          backgroundColor: '#C2C2C280',
          icon: null,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={
        <div className="flex items-center gap-2">
          {formatConstant(status)}
          {config.icon}
        </div>
      }
      className={`capitalize rounded-sm ${config.className}`}
      size={size}
      style={{ backgroundColor: config.backgroundColor }}
    />
  );
};
